import { useSelector, useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { updateThreadMeta as updateThreadMetaAction } from '../redux/modules/tickets/actions';

const defaultValue = {};
const useThreadMeta = ({ ticketId } = {}) => {
  const dispatch = useDispatch();
  const threadMeta = useSelector(store => store.tickets.threadMeta[ticketId] || defaultValue);

  const updateThreadMeta = useCallback(
    partialData => {
      dispatch(
        updateThreadMetaAction({
          ...partialData,
          id: ticketId
        })
      );
    },
    [dispatch, updateThreadMetaAction, ticketId]
  );

  return {
    threadMeta,
    updateThreadMeta
  };
};

export default useThreadMeta;
